import { useId, useRef, useState } from 'react'
import { FileText, Instagram, Linkedin } from 'lucide-react'
import './portrait-business-card.css'

const profileLinks = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/jay-patel-pm', icon: Linkedin, external: true },
  { label: 'Full résumé', href: '/cv/jaypatel', icon: FileText, external: false },
  { label: 'Instagram: @jaybhai', href: 'https://www.instagram.com/jaybhai/', icon: Instagram, external: true },
  { label: 'X: @jaybhai', href: 'https://x.com/jaybhai', icon: null, external: true },
]

export function PortraitBusinessCard() {
  const [flipped, setFlipped] = useState(false)
  const bioId = useId()
  const frontButton = useRef<HTMLButtonElement>(null)
  const backButton = useRef<HTMLButtonElement>(null)
  const flip = (showBio: boolean) => {
    setFlipped(showBio)
    requestAnimationFrame(() => (showBio ? backButton : frontButton).current?.focus({ preventScroll: true }))
  }
  return <div className={`portrait portrait-business-card${flipped ? ' is-flipped' : ''}`} onKeyDown={event => {
    if (event.key === 'Escape' && flipped) { event.preventDefault(); event.stopPropagation(); flip(false) }
  }}>
    <div className="portrait-card-inner">
      <button ref={frontButton} type="button" className="portrait-card-face portrait-card-front" onClick={() => flip(true)} aria-label="Show Jay Patel’s short bio" aria-hidden={flipped} tabIndex={flipped ? -1 : 0}>
        <img src="/site-direction/assets/jay-about-photo.jpg" alt="Jay Patel holding a paper browser-window frame around his face" loading="lazy" decoding="async" width="2000" height="2000" />
      </button>
      <div className="portrait-card-face portrait-card-back" aria-hidden={!flipped}>
        <div className="portrait-card-heading"><h3 className="portrait-card-name ds-type-card">Jay Patel</h3><p className="portrait-card-brand ds-type-label">Dugout</p></div>
        <p id={bioId} className="portrait-card-bio">25+ years in product, growth and community. I help smaller teams find clarity, make useful things and evolve their work.</p>
        <div className="portrait-card-profiles" role="group" aria-label="Profiles and résumé">
          {profileLinks.map(({ label, href, icon: Icon, external }) => <a key={href} href={href} tabIndex={flipped ? 0 : -1} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} title={label} aria-label={`${label}${external ? ' (opens in a new tab)' : ''}`}>
            {Icon ? <Icon size={19} strokeWidth={1.7} aria-hidden="true" /> : <span className="portrait-social-x" aria-hidden="true">X</span>}
          </a>)}
        </div>
        <div className="portrait-card-footer">
          <a href="/contact" tabIndex={flipped ? 0 : -1}><span className="link-label">Contact</span><span aria-hidden="true">↗</span></a>
          <button ref={backButton} type="button" tabIndex={flipped ? 0 : -1} onClick={() => flip(false)} aria-describedby={flipped ? bioId : undefined}>Back to photo</button>
        </div>
      </div>
    </div>
  </div>
}
